var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "button-holder top-btn-holder" }, [
    _c("div", { staticClass: "btn-item back-item" }, [
      _vm.isNeedBack
        ? _c(
            "button",
            {
              staticClass: "back",
              on: {
                click: function ($event) {
                  _vm.isEditTrade = false
                  _vm.isNewTrade = false
                },
              },
            },
            [
              _c("img", {
                staticClass: "long-arrow light-arrow",
                attrs: { src: "/img/long-arrow.png", alt: "" },
              }),
              _vm._v(" "),
              _c("img", {
                staticClass: "long-arrow dark-arrow",
                attrs: { src: "/img/long-arrow-dark.png", alt: "" },
              }),
              _vm._v(" "),
              _c("span", [_vm._v("Special Trades")]),
            ]
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "btn-item" }, [
      _c(
        "button",
        {
          staticClass: "btn",
          on: {
            click: function ($event) {
              return _vm.newTrade()
            },
          },
        },
        [_vm._v("New Special Trade")]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }